import { CURRENCY_SYMBOL } from "@/data/categories";

export function priceLabel(listing, t) {
  const sym = CURRENCY_SYMBOL[listing.currency] || listing.currency + " ";
  const unit =
    listing.price_unit === "task"
      ? t("per_task")
      : listing.price_unit === "day"
      ? t("per_day")
      : t("per_hour");
  if (listing.price_type === "fixed") {
    return { main: `${sym}${listing.price_fixed}`, unit };
  }
  const lo = listing.price_min;
  const hi = listing.price_max;
  const range = hi && hi !== lo ? `${sym}${lo}–${sym}${hi}` : `${sym}${lo}`;
  return { main: range, unit };
}

export function fmt(sym, n) {
  return `${sym}${Number(n).toFixed(2)}`;
}
